import data from "./data"

import { DATA_TYPE, getData as getLocalData } from "./userData"

export const getData = () => {
  const customData = getLocalData(DATA_TYPE.CUSTOM) || {}
  return Object.keys({ ...data, ...customData })
}

export const searchProduct = (text) => {
  const result = getData().filter(
    (item) =>
      String(item)
        .toLocaleLowerCase()
        .search(String(text).trim().toLocaleLowerCase()) !== -1
  )
  return result
}
